import React, { useEffect, useState } from 'react'

const AdminLogs: React.FC = () => {
  const [fullLogs, setFullLogs] = useState<string>('Loading...')
  const [displayLines, setDisplayLines] = useState<number | ''>('')
  const [logs, setLogs] = useState<string>('Loading...')

  const fetchLogs = async () => {
    const token = localStorage.getItem('lcToken')
    const adminToken = localStorage.getItem('adminToken')
    const requestedLines =
      displayLines === '' ? 1000 : Math.min(displayLines, 5000)
    const headers: Record<string, string> = {
      Authorization: `Bearer ${token}`
    }
    if (adminToken) {
      headers.admin = adminToken
    }

    try {
      const res = await fetch(
        `${process.env.REACT_APP_REST_URL}logs?lines=${requestedLines}`,
        { headers }
      )
      if (!res.ok) throw new Error('Failed to fetch logs')
      const text = await res.text()
      setFullLogs(text)
      setLogs(text)
    } catch (err) {
      setFullLogs('Error loading logs.')
      setLogs('Error loading logs.')
      console.error(err)
    }
  }

  useEffect(() => {
    fetchLogs()
  }, [])

  useEffect(() => {
    if (fullLogs === 'Loading...' || fullLogs === 'Error loading logs.') {
      setLogs(fullLogs)
      return
    }
    const lines = fullLogs.split('\n')
    if (displayLines === '' || displayLines >= lines.length) {
      setLogs(fullLogs)
    } else if (displayLines > 0) {
      setLogs(lines.slice(-displayLines).join('\n'))
    } else {
      setLogs('')
    }
  }, [displayLines, fullLogs])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value
    const num = val === '' ? '' : Number(val)
    if (
      num === '' ||
      (Number.isInteger(num) && num >= 1 && num <= 5000)
    ) {
      setDisplayLines(num)
    }
  }

  return (
    <div>
      <div
        style={{
          position: 'sticky',
          top: 0,
          backgroundColor: '#fff',
          padding: '1em',
          borderBottom: '1px solid #ccc',
          zIndex: 1000
        }}
      >
        <h1>Admin Logs</h1>
        <label>
          Show last{' '}
          <input
            type="number"
            min="1"
            max="5000"
            value={displayLines}
            onChange={handleChange}
            placeholder="1000"
            style={{ width: '60px' }}
          />{' '}
          lines (default 1000, maximum 5000)
        </label>{' '}
        <button onClick={fetchLogs}>Refresh</button>
      </div>
      <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
        {logs}
      </pre>
    </div>
  )
}

export default AdminLogs
